module.exports = __webpack_public_path__ + "img/logo_mini.d9e1e0b6.png";